import React from 'react';
import '../styles/gallery.css'; 

export default function GallerySection() {
  return (
    <section className="gallery">
      <img
        src="/dibujos/portafolio3.png"
        alt="galeria"
        className="gallery-image"
        loading="lazy"
      />
      
    </section>
  );
}